import React, { useState } from 'react';
import { AlertBanner } from '@spark';

const formatVersionForDisplay = (v) => {
  if (v === null || v === undefined || v === '') return '';
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  return n % 1 === 0 ? `${n}.0` : String(v);
};

const IncompleteTrainingAlert = ({ show, version, style }) => {
  const [dismissed, setDismissed] = useState(false);

  if (!show || dismissed) return null;

  const v = formatVersionForDisplay(version);
  const suffix = v ? ` (V${v})` : '';

  return (
    <div style={{ marginBottom: '0.5rem', ...(style || {}) }}>
      <AlertBanner
        feedback="warning"
        showIcon
        text={`The training process evaluation has not been completed for the current version${suffix}. The evaluation results shown here do not yet include the outcome from the most recent run.`}
        showButton={false}
        showCloseButton
        onCloseClick={() => setDismissed(true)}
      />
    </div>
  );
};

export default IncompleteTrainingAlert;
